<!-- 全屏 -->
<template>
  <el-tooltip
    effect="dark"
    :content="isFullScreen ? $t('main_header_exit_full_screen') : $t('main_header_full_screen')"
    placement="bottom"
  >
    <el-button class="fullscreen-button" type="text" size="medium" @click="handleFullScreen">
      <img
        v-show="isFullScreen"
        src="@/assets/svg/fullscreen-exit.svg"
        class="fullscreen-icon-i"
        alt=""
      />
      <img
        v-show="!isFullScreen"
        src="@/assets/svg/fullscreen.svg"
        class="fullscreen-icon-i"
        alt=""
      />
    </el-button>
  </el-tooltip>
</template>

<script>
import { defineComponent, onBeforeUnmount, onMounted, ref } from 'vue'

export default defineComponent({
  name: 'FullscreenButton',
  setup() {
    const isFullScreen = ref(false)

    // 同步浏览器真实全屏状态，覆盖按钮点击、Esc 退出等场景。
    const updateFullScreenStatus = () => {
      isFullScreen.value = !!document.fullscreenElement
    }

    onMounted(() => {
      updateFullScreenStatus()
      document.addEventListener('fullscreenchange', updateFullScreenStatus)
    })

    onBeforeUnmount(() => {
      document.removeEventListener('fullscreenchange', updateFullScreenStatus)
    })

    // Fullscreen API 必须由用户手势触发，因此保留在按钮点击回调里。
    const handleFullScreen = () => {
      try {
        if (!document.fullscreenElement) {
          document.documentElement.requestFullscreen().catch(err => {
            console.error(`Fullscreen error: ${err.message}`)
          })
          return
        }

        if (document.exitFullscreen) {
          document.exitFullscreen()
        }
      } catch (error) {
        console.log(error)
      }
    }

    return {
      isFullScreen,
      handleFullScreen
    }
  }
})
</script>

<style lang="scss" scoped>
.fullscreen-button {
  margin-left: 20px;
}

.fullscreen-icon-i {
  width: 18px;
  height: 18px;
  vertical-align: middle;
}
</style>
